export default __webpack_public_path__ + "static/media/img--creek-1.3146d6b1.jpg";